.reverse {
  svg {
    transform: scaleY(-1);
  }
}

.button {
  height: auto !important;
}

.panel {
  min-width: 280px;
  max-height: 320px;
  overflow-y: auto;
}
